import React from "react";
import { IonSkeletonText } from "@ionic/react";
import HomePageSkeleton from "../../pages/parhato2/home/homePageSkeleton";

const AuthLoadingSkeleton = () => {
  return (
    <div className="min-h-screen bg-white pt-[env(safe-area-inset-top)]">
      <div className="h-16 flex items-center px-3">
        <IonSkeletonText animated className="w-full h-10 rounded-xl m-0" />
      </div>
      <HomePageSkeleton />
    </div>
  );
};

export default AuthLoadingSkeleton;
